import { z } from "zod";

interface FeatureToggles {
  /** If `true` the "AUTOVIO Lab" is accessible in the "My Profile" tab (default value: `false`). */
  lab: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface FeatureTogglesForInstructors extends FeatureToggles {}

export const FeatureTogglesForStudentsSchema = z
  .object({
    /**
     * If `true` the student can use the theory learning section in the mobile app
     * (default value: depends on booked trainings).
     */
    canLearnTheoryInMobileApp: z.optional(z.boolean()),
    /** If `true` the student can book theory lessons (default value: depends on booked trainings). */
    canBookTheoryLessons: z.optional(z.boolean()),
    /** If `true` the student can cancel booked theory lessons (default value: true). */
    canCancelTheoryLessons: z.optional(z.boolean()).default(true),
    /** If `true` the student can book driving lessons (default value: depends on booked trainings). */
    canBookDrivingLessons: z.optional(z.boolean()).default(true),
    /** If `true` the student can cancel booked driving lessons (default value: true). */
    canCancelDrivingLessons: z.optional(z.boolean()).default(true),
    /** If `true` the student can have prepaid credits (default value: true). */
    canHavePrepaidCredits: z.optional(z.boolean()).default(true),
    /** If `true` the student can have free credits (default value: true). */
    canHaveFreeCredits: z.optional(z.boolean()).default(true),
    /** If `true` manual invoices can be created for the student (default value: true). */
    canCreateManualInvoices: z.optional(z.boolean()).default(true),
    /** If `true` the student can make payments (default value: true). */
    canCreatePayment: z.optional(z.boolean()).default(true),
    /** If `true` invoice details of the student can be viewed (default value: true). */
    canViewInvoiceDetails: z.optional(z.boolean()).default(true),
  })
  .optional()
  .default({
    canCancelTheoryLessons: true,
    canBookDrivingLessons: true,
    canCancelDrivingLessons: true,
    canHavePrepaidCredits: true,
    canHaveFreeCredits: true,
    canCreateManualInvoices: true,
    canCreatePayment: true,
    canViewInvoiceDetails: true,
  });

export type FeatureTogglesForStudents = z.infer<typeof FeatureTogglesForStudentsSchema>;
